import { JL } from 'jsnlog';

const logger = JL('VueLogger');

function getTimestampNow(): string {
  const date = new Date();
  const formattedDate = date.toISOString().slice(0, 19).replace('T', ' ');
  return formattedDate;
}

function logInfo(message: string, context: unknown = null): void {
  logger.info({
    timestamp: getTimestampNow(),
    message: message,
    context: context,
  });
}

function logError(message: string, context: unknown = null): void {
  logger.error({
    timestamp: getTimestampNow(),
    message: message,
    context: context,
  });
}

function logDebug(message: string, context: unknown = null): void {
  logger.debug({
    timestamp: getTimestampNow(),
    message: message,
    context: context,
  });
}

function logTrace(message: string, context: unknown = null): void {
  logger.trace({
    timestamp: getTimestampNow(),
    message: message,
    context: context,
  });
}

export default function useLogger() {
  return {
    logTrace: logTrace,
    logDebug: logDebug,
    logInfo: logInfo,
    logError: logError,
  };
}
